import { render, staticRenderFns } from "./Jatekszabaly.vue?vue&type=template&id=12aaef1c&"
import script from "./Jatekszabaly.vue?vue&type=script&lang=js&"
export * from "./Jatekszabaly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports